import { render, staticRenderFns } from "./SyncOrder.vue?vue&type=template&id=1ddbca5c&scoped=true"
import script from "./SyncOrder.vue?vue&type=script&lang=js"
export * from "./SyncOrder.vue?vue&type=script&lang=js"
import style0 from "./SyncOrder.vue?vue&type=style&index=0&id=1ddbca5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddbca5c",
  null
  
)

export default component.exports